module.exports = __webpack_public_path__ + "static/media/onda-roja.48c29194.png";